import List from "@/components/list";
import route from "@/router";

const Table = args => {
  const AccountTableConfig = [
    {
      label: "消息模板",
      prop: "mqTemplateContent",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "消息分类",
      prop: "pushBizTypeName",
      minWidth: "100"
    },
    {
      label: "推送数量",
      prop: "sendCount",
      minWidth: "100"
    },
    {
      label: "推送中",
      minWidth: "100",
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            route.push({
              path: "/pushMessage/sended",
              query: { id: vo.row.uuid, mqTemplateId: vo.row.mqTemplateId }
            });
          }}
        >
          {vo.row.sendGoingCount}
        </el-button>
      )
    },
    {
      label: "推送成功",
      minWidth: "100",
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            route.push({
              path: "/pushMessage/success",
              query: { id: vo.row.uuid, mqTemplateId: vo.row.mqTemplateId }
            });
          }}
        >
          {vo.row.sendSuccessCount}
        </el-button>
      )
    },
    {
      label: "发送失败",
      minWidth: "100",
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            route.push({
              path: "/pushMessage/failure",
              query: { id: vo.row.uuid, mqTemplateId: vo.row.mqTemplateId }
            });
          }}
        >
          {vo.row.sendFailCount}
        </el-button>
      )
    },
    {
      label: "推送人",
      prop: "sendUserName",
      minWidth: "100"
    },
    {
      label: "推送时间",
      prop: "pushSendDate",
      minWidth: "130",
      showOverflowTooltip: true
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};

export default Table;
